var exports = {
  "UT": "MenuItems.module__roleIcon___cktfUD",
  "yk": "MenuItems.module__roleContainer___cktfUD",
  "S3": "MenuItems.module__roleName___cktfUD",
  "nT": "MenuItems.module__roleDisabled___cktfUD",
  "u8": "MenuItems.module__readonlyRoleItem___cktfUD",
  "zQ": "MenuItems.module__readonlyRoleSpacer___cktfUD",
  "ec": "MenuItems.module__flexColumn___cktfUD",
  "Kk": "MenuItems.module__icon___cktfUD",
  "Bx": "MenuItems.module__iconSmall___cktfUD",
};

module.exports = exports;
